import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { AppContext } from "./lib/AppContext";

import updateData from "./updateData";

class Updates extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>RPGONE Translations - News Updates</title>
	  <meta name="title" content="RPGONE Translations - News Updates" />
	  {/*<meta name="description" content="RPGONE Translations - Snes / Super Famicom Game Hacking and English Translations" />*/}
        </Helmet>

        {/* pass the UpdatesFilter search value */}
        <AppContext.Consumer>
          {({ search }) => <DisplayUpdatesText search={search} />}
        </AppContext.Consumer>
      </div>
    );
  }
}

//split the updateData into individual posts
class DisplayUpdatesText extends React.Component {
  constructor(props) {
    super(props);

    this.state = { search: this.props.search };
  }


  render() {
    var arr = [];
    Object.keys(updateData)
      .sort()
      .reverse()
      .forEach(function(key) {
        arr.push(updateData[key]);
      });

    //sort arr by id so the most recent updates are first
    arr.sort((a, b) => b.id - a.id);

    return arr.map(item => (
      <div key={item.id}>
        {this.props.search === item.filter || this.props.search === "all" ? (
          <DisplayUpdatesTextChild
            key={item.key}
            date={item.date}
            subtitle={item.subtitle}
            content={item.content}
            filter={item.filter}
            search={this.props.search}
          />
        ) : null}
      </div>
    ));
  }
}

//display a post
class DisplayUpdatesTextChild extends React.Component {
  constructor(props) {
    super(props);
    this.state = { search: this.props.search };
  }

  render() {
    return (
      <div className="col-centered">
        <div className="panel panel-primary">
          <div className="panel-heading">
            <span className="subtitle">
              <span>
                <div dangerouslySetInnerHTML={{ __html: this.props.date }} />
              </span>
              <b>
                <div
                  dangerouslySetInnerHTML={{ __html: this.props.subtitle }}
                />
              </b>
            </span>
          </div>
          <div className="panel-body">
            {this.props.content.map((content, index) => (
              <content key={index}>
                {content.label === "text" ? (
                  <span dangerouslySetInnerHTML={{ __html: content.value }} />
                ) : null}
                {content.label === "img" ? (
                  <div className="center-image">
                    {content.value.map((contenta, index) => (
                      <span key={index}>{contenta.value} </span>
                    ))}
                  </div>
                ) : null}
                {content.label === "code" ? (
                  <span>
                    {content.value.map((contenta, index) => (
                      <span key={index}>{contenta.value} </span>
                    ))}
                  </span>
                ) : null}
              </content>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Updates);



// WEBPACK FOOTER //
// ./src/Updates.js